<template>
  <div class="login">
    <div class="left"></div>
    <div class="right">
      <div class="fanhui" v-if="remember">
        <span @click="remember = false"> 返回登录 </span>
      </div>
      <div class="logo" :class="remember ? 'marginA' : 'marginB'">
        <img src="@/assets/images/hpcopy/logo.png" />
      </div>
      <div class="info" v-if="!remember">
        <div class="zhang" v-if="!saomaLogin">
          <div class="tit">
            <div
              class="title"
              :class="{ background: isBackground(index) }"
              v-for="(item, index) in titleList"
              :key="index"
              @click="handleClickTitle(index)"
            >
              <div>
                {{ item }}
              </div>
              <div :class="{ line: isBackground(index) }"></div>
            </div>
          </div>
          <div class="content" v-if="marketIndex == 0">
            <el-input
              class="phone"
              clearable
              v-model="phoneValue"
              placeholder="请输入手机号"
            ></el-input>
            <div class="div">
              <el-input
                class="number"
                clearable
                v-model="verificationValue"
                placeholder="请输入验证码"
              ></el-input>
              <!-- <el-input clearable v-model="phoneValue" placeholder="请输入验证码"></el-input> -->
              <el-button
                class="click"
                :class="{ 'is-active': phoneValue.length == 11 }"
                :disabled="phoneValue.length != 11"
                @click="getCode('YZMDL')"
              >
                <!-- 获取验证码 -->
                {{
                  second === totalSecond ? "获取验证码" : second + `秒后重新发送`
                }}
              </el-button>
            </div>
          </div>
          <div class="content" v-if="marketIndex == 1">
            <el-input
              class="phone"
              clearable
              v-model="account"
              placeholder="请输入账号"
            ></el-input>
            <el-input
              class="phone pwd"
              show-password
              clearable
              v-model="password"
              placeholder="请输入密码"
            ></el-input>
            <div class="wangji">
              <!-- <el-radio v-model="rememberPassword" label="1">记住密码</el-radio> -->
              <div class="jizhumiam">
                <img v-if="rememberPassword==1" @click="rememberPassword=2" src="../../assets/images/jzmm.png" alt="">
                <div  v-if="rememberPassword==2" @click="rememberPassword=1"></div>
                <span>记住密码</span>
              </div>
              <div @click="remember = true">忘记密码</div>
            </div>
          </div>
          <el-button
            :disabled="
              marketIndex == 0
                ? !(phoneValue != '' && verificationValue != '')
                : !(account != '' && password != '')
            "
            @click="LogOn"
            class="el-btn"
            type="primary"
            round
            >登录</el-button
          >

        <div class="saomadengl" @click="qiehuansaoma">
          <img src="../../assets/images/saoma.png" alt="" />
          <span>扫码登录</span>
        </div>

        </div>
        <div class="erweim" v-else>
          <div class="erweimaImg" :class="{'erweimazhezhao' : erweimazhezhao}">
            <img :src="erweimaUrl" alt="">
          </div>
          <div class="shuaxin">
            <div>请使用微信扫描二维码登录</div>
            <div class="ssbtn" @click="getQr">
              <img src="../../assets/images/shuaxin.png" alt="" />
              <span>刷新</span>
            </div>
          </div>
          <div class="anniuzu">
            <div class="shoujibutn shouji" @click="duanxi(0)">
              <img src="../../assets/images/shouji.png" alt="" />
              <span>短信登录</span>
            </div>
            <div class="shoujibutn"  @click="duanxi(1)">
              <img src="../../assets/images/suo.png" alt="" />
              <span>密码登录</span>
            </div>
          </div>
        </div>
        
        <div class="tongyi">
            登录即同意
            <span @click="xieyiyi">《服务协议》</span>
            和
            <span @click="xieyier">《隐私政策》</span>
          </div>
      </div>
      <div class="info" v-else>
        <div class="content rember">
          <el-input
            class="phone"
            clearable
            v-model="rememberForm.mobile"
            placeholder="请输入手机号"
          ></el-input>
          <div>
            <el-input
              class="number"
              clearable
              v-model="rememberForm.code"
              placeholder="请输入验证码"
            ></el-input>
            <!-- <el-input clearable v-model="phoneValue" placeholder="请输入验证码"></el-input> -->
            <el-button
              class="click"
              :class="{ 'is-active': rememberForm.mobile.length == 11 }"
              :disabled="rememberForm.mobile.length != 11"
              @click="getCode('ZHDLMM')"
              >
              {{
                second === totalSecond ? "获取验证码" : second + `秒后重新发送`
              }}
              </el-button
            >
          </div>
          <el-input
            class="phone"
            clearable
            v-model="rememberForm.password"
            show-password
            placeholder="设置登录密码"
          ></el-input>
          <el-input
            class="phone"
            clearable
            v-model="rememberForm.password_confirm"
            show-password
            placeholder="请再次确认登录密码"
          ></el-input>
        </div>
        <el-button
          class="el-btn"
          type="primary"
          :disabled="
            rememberForm.mobile == '' &&
            rememberForm.code == '' &&
            rememberForm.password == '' &&
            rememberForm.password_confirm == ''
          "
          round
          @click="remberLogin"
        >
          确认并登录
        </el-button>
      </div>
    </div>

    <!-- 协议 -->
    <el-dialog
        :title="ratetitle"
        :visible.sync="dialogVisiblexieyi"
        width="30%">
        <!-- <span>{{ratetext}}</span> -->
        <div v-html="ratetext"></div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisiblexieyi = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisiblexieyi = false">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { indexPolicy,checkScanLoginQrcodeStatus,getQrCode,loginAccount, smsSendCode, userResetPassword,userCenter,userAuthenticationInfo,supplierInfo } from "@/api/api";
export default {
  props:{
    chongxindiaoyong:{
      type:Boolean,
      required:true
    }
  },
  data() {
    return {
      highlightBackground: 0,
      marketIndex: 0,
      titleList: ["验证码登录", "账号密码登录"],
      // 手机号
      phoneValue: "",
      // 手机号验证码
      verificationValue: "",
      // 登录账号
      account: "",
      // 登录账号密码
      password: "",
      // 记住密码
      rememberPassword: 2,
      // 忘记密码页面是否展示
      remember: false,
      rememberForm: {
        terminal:'4',
        mobile: "",
        code: "",
        password: "",
        password_confirm: "",
      },
      parameter: {
        invite_code:'',
        account: "",
        terminal: "4",
        scene: "",
        password: "",
        code: "",
      },
      // 登录按钮是否可以点击
      isClick: true,
      // 判断当前所处的验证码登录页面
      codedown:false,
      // 验证码倒计时
      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      token:'',
      saomaLogin:true, //扫码登录
      erweimaUrl:'',
      uniqId:'',
      intervalId: null, // 定时器 id
      erweimazhezhao:false,

      dialogVisiblexieyi:false,
      ratetitle:'',
      ratetext:'',
      xieyiType:'service',
      saomaForm:{},
    };
  },
  setup() {},
  methods: {
    // 富文本处理
    showHtml(str) {
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;nbsp;/g, "\u3000");
    },
    // 《会员服务协议》
    async getindexPolicy(){
      try {
        const res = await indexPolicy({type:this.xieyiType});
        // const res = await axios.get('https://dhctest.yunfangshi.com/api/index/policy?type=service')
        this.ratetitle = this.showHtml(res.data.title);
        this.ratetext = this.showHtml(res.data.content);
      } catch (error) {
        console.log(error, "获取平台协议失败");
      }
    },
    xieyiyi(){
      this.dialogVisiblexieyi = true
      this.xieyiType='service'
      this.getindexPolicy()
    },
    xieyier(){
      this.dialogVisiblexieyi = true
      this.xieyiType='privacy'
      this.getindexPolicy()
    },
    handleClickTitle(index) {
      this.highlightBackground = index;
      this.marketIndex = index;
      if(index==1){
        if(JSON.parse(localStorage.getItem('remember'))){
          let a = JSON.parse(localStorage.getItem('remember'))
          this.account = a.account
          this.password = a.password
          // this.rememberPassword = 1
        }
      }
    },
    // 触发选中样式
    isBackground(index) {
      return this.highlightBackground === index;
    },
    async LogOn() {
      // scene 1-账号密码登录 2-手机号验证码登录
      // terminal 登陆类型 ；4-电脑PC

      // localStorage.setItem('isLogin', true);
      if (this.$route.query.sn != undefined && this.$route.query.sn != null && this.$route.query.sn !='') {
        this.parameter.invite_code = this.$route.query.sn
      }
      if (this.marketIndex == 0) {
        // 验证码
        this.parameter.scene = "2";
        this.parameter.account = this.phoneValue;
        this.parameter.password = "";
        this.parameter.code = this.verificationValue;
      } else if (this.marketIndex == 1) {
        // 账号
        this.parameter.scene = "1";
        this.parameter.account = this.account;
        this.parameter.password = this.password;
        this.parameter.code = "";
        
      }
      // 登录成功再存
      // localStorage.setItem("nickname", this.parameter.account);
      // localStorage.setItem('isLogin', true);

      try {
        const res = await loginAccount(this.parameter);
        if (res.code == 1) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('isLogin', true);
          this.token=res.data.token

          let vip_expire_time = res.data.is_vip==0?'--':res.data.vip_expire_time
          localStorage.setItem(
              "userInfo",
              JSON.stringify({
                sn: res.data.sn,
                avatar: res.data.avatar,
                nickname: res.data.nickname,
                mobile: res.data.mobile,
                is_vip: res.data.is_vip,
                is_supplier: res.data.is_supplier,
                vip_expire_time:vip_expire_time,
                supplier_id:res.data.supplier_id,
                is_authentication:res.data.is_authentication,
                supplier_is_authentication:res.data.supplier_is_authentication,
                supplier_reject_reason:res.data.supplier_reject_reason,
                
              })
            );

            this.supplier_id = res.data.supplier_id

            if(this.marketIndex == 1 && this.rememberPassword==1){
              localStorage.setItem('remember',JSON.stringify({
                account:this.account,
                password:this.password,
              }))
            }

            this.account = ''
            this.password = ''
            this.phoneValue = ''
            this.verificationValue = ''
            this.marketIndex = 0
            this.highlightBackground = 0
            this.rememberPassword = 2


          this.getUserInfo()
          // 用户认证信息
          if(res.data.is_authentication==2){
            this.getUserAuthentication()
          }
          // 供应商认证信息
          if(res.data.supplier_is_authentication==2){
            this.getSupplierInfo()
          }

          this.$emit("message", {
            userInfo: res.data,
            dialogVisible: false,
            chongxindiao:false,
          });
          this.$message({
            offset:80,
            message: "登录成功",
            type: "success",
          });
          if(res.data.vip_tip==1){
            this.$notify({
                title: '',
                message: res.data.vip_tip_message,
                duration: 0,
                offset: 50,
                position: 'bottom-right',
              })
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error,"登录失败");
      }
      // 父子传值  关闭弹窗
    },
    // 获取用户信息，进行存储
    // 获取个人信息
    async getUserInfo(){
      let headers = {
          'token':this.token
      }
      try {
          const res = await userCenter(headers);
          if(res.code==1){
            let storedObject = localStorage.getItem('userInfo');

            if(storedObject){
                let obj = JSON.parse(storedObject);
                obj.freeze_money = res.data.freeze_money;
                obj.user_money = res.data.user_money;
                obj.total_amount = Number(res.data.user_money) + Number(res.data.freeze_money);
                localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
            }
          }else{
            clearInterval(this.intervalId);
            this.intervalId = null // 重置定时器
          }
      } catch (error) {
          clearInterval(this.intervalId);
          this.intervalId = null // 重置定时器
          console.log(error,'获取用户信息失败');
      }
    },
    // 校验手机号
    validFn() {
      let dianhua = this.phoneValue
      if(this.remember){
        dianhua=this.rememberForm.mobile
      }
      if (!/^1[3-9]\d{9}$/.test(dianhua)) {
        // this.$toast('请输入正确的手机号')
        // alert('1121')
        // this.$message.error("请输入正确的手机号");
        this.$message({
          // duration:0,
          message: "请输入正确的手机号",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 获取验证码
    async getCode(e) {
      // 判断手机号验证是否通过
      if (!this.validFn()) {
        return;
      }

      let dianhua = this.phoneValue
      if(this.remember){
        dianhua=this.rememberForm.mobile
      }

      if(this.remember != this.codedown){
        this.totalSecond=60
        this.second=60
        this.timer=null
        this.codedown=!this.remember
      }
      // mobile 手机号
      // scene YZMDL-验证码登录、BDSJHM-绑定手机号、BGSJHM-变更手机号、ZHDLMM-找回密码
      try {
        // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
        if (!this.timer && this.second === this.totalSecond) {
          // 开启倒计时
          this.timer = setInterval(() => {
            this.second--;

            if (this.second <= 0) {
              clearInterval(this.timer);
              this.timer = null; // 重置定时器 id
              this.second = this.totalSecond; // 归位
            }
          }, 1000);

          // 调用接口
          let parame = {
            mobile: dianhua,
            scene: e,
          };
          const resCode = await smsSendCode(parame);
          if (resCode.code == 1) {
            console.log(resCode, "获取成功");
          }else{
            console.log(resCode, "获取失败");
          }
        } else {
          // this.$message.error('请输入正确的手机号');
          this.$message({
            message: "您已发送！",
            type: "warning",
          });
        }
      } catch (error) {
        console.log(error,"获取失败");
      }
    },
    // 忘记密码登录
    async remberLogin(){
      // this.rememberForm.mobile = "2";
      // this.rememberForm.code = this.phoneValue;
      // this.rememberForm.password = "";
      // this.rememberForm.password_confirm = this.verificationValue;
      try {
        const res = await userResetPassword(this.rememberForm);
        if (res.code == 1) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('isLogin', true);
          let vip_expire_time = res.data.is_vip==0?'--':res.data.vip_expire_time

          localStorage.setItem(
              "userInfo",
              JSON.stringify({
                sn: res.data.sn,
                avatar: res.data.avatar,
                nickname: res.data.nickname,
                mobile: res.data.mobile,
                is_vip: res.data.is_vip,
                is_supplier: res.data.is_supplier,
                vip_expire_time:vip_expire_time,
                supplier_id:res.data.supplier_id,
                is_authentication:res.data.is_authentication,
                supplier_is_authentication:res.data.supplier_is_authentication,
                supplier_reject_reason:res.data.supplier_reject_reason,
                
              })
            );

            this.supplier_id = res.data.supplier_id
          this.token=res.data.token
          this.getUserInfo()
          if(res.data.is_authentication==2){
            this.getUserAuthentication()
          }
          if(res.data.supplier_is_authentication==2){
            this.getSupplierInfo()
          }
          this.remember=false

          this.$emit("message", {
            userInfo: res.data,
            dialogVisible: false,
            chongxindiao:false,
          });
          this.$message({
            offset:80,
            message: "登录成功",
            type: "success",
          });
          if(res.data.vip_tip==1){
            this.$notify({
                title: '',
                message: res.data.vip_tip_message,
                duration: 0,
                offset: 50,
                position: 'bottom-right',
              })
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error,"登录失败");
      }
    },
    // 登录成功  判断用户认证是否通过  通过将企业名称  联系邮箱也存储一下
    async getUserAuthentication() {
      let token = localStorage.getItem("token");
      let headers = {
        token: token,
      };
      try {
        const res = await userAuthenticationInfo(headers);
        if (res.code == 1) {
          // 更新本地用户认证信息
          let storedObject = localStorage.getItem('userInfo');
          if (storedObject) { 
            let obj = JSON.parse(storedObject);
            obj.email = res.data.email;
            obj.enterprise_name = res.data.enterprise_name;
            localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
          }      
        }else{
            clearInterval(this.intervalId);
            this.intervalId = null // 重置定时器
          }
      } catch (error) {
        clearInterval(this.intervalId);
        this.intervalId = null // 重置定时器
        console.log(error,"获取用户认证信息失败");
      }
    },
    // 登录成功  判断供应商认证是否通过  通过将供应商认证的企业名称  联系邮箱存储一下
    async getSupplierInfo() {
      let token = localStorage.getItem("token");
      let headers = {
        token: token,
      };
        try {
          const res = await supplierInfo({
              supplier_id:this.supplier_id
          }, headers);
          if(res.code==1){
            let vip_expire_time = res.data.is_vip==0?'--':res.data.vip_expire_time
              let userInfo = JSON.parse(localStorage.getItem('userInfo'))
              userInfo.supplier_enterprise_name=res.data.enterprise_name
              userInfo.supplier_email=res.data.email
              userInfo.supplier_is_vip=res.data.is_vip
              userInfo.supplier_expire_time=vip_expire_time
              localStorage.setItem('userInfo',JSON.stringify(userInfo))
          }else{
            clearInterval(this.intervalId);
            this.intervalId = null // 重置定时器
          }
        } catch (error) {
          clearInterval(this.intervalId);
          this.intervalId = null // 重置定时器
            console.log(error,"获取列表失败");
        }
    },
    duanxi(index){
      this.saomaLogin=false
      this.marketIndex=index
      this.highlightBackground=index
      clearInterval(this.intervalId); 
      if(index==1){
        if(JSON.parse(localStorage.getItem('remember'))){
          let a = JSON.parse(localStorage.getItem('remember'))
          this.account = a.account
          this.password = a.password
          // this.rememberPassword = 1
        }
      }
    },
    // 切换为扫码登录
    // 重新获取二维码
    qiehuansaoma(){
      this.saomaLogin=true
      this.getQr()
    },
    // 获取二维码
    async getQr(){
      this.erweimazhezhao=false
      clearInterval(this.intervalId);
      this.intervalId = null // 重置定时器
      try {
        const res = await getQrCode({
          invite_code:  this.$route.query.sn,
        }) 
        if(res.code==1){
          this.erweimaUrl = res.data.url
          this.uniqId = res.data.uniqid
          this.saoma()
        }else{
          this.$message({
            type:'error',
            message:res.msg
          })
        }
      } catch (error) {
        console.log('失败',error);
      }
    },
    // 判断是否扫码登录
    saoma(){
      // 创建定时器  一秒调用一次  知道成功或过期
      this.intervalId = setInterval(async () => {
        try {
          const res = await checkScanLoginQrcodeStatus({
            uniqid:this.uniqId,
          })
          if(res.code==1){ //过期  清除定时器
            // 扫码状态：0未扫码、1已过期、2已扫码、3授权失败、4授权成功
            if(Number(res.data.status)==1 || Number(res.data.status)==3){ //过期  清除定时器
              this.erweimazhezhao=true
              clearInterval(this.intervalId);
              this.intervalId = null // 重置定时器
            }else if(Number(res.data.status) == 4){ //授权成功  清除定时器
              clearInterval(this.intervalId);
              this.intervalId = null // 重置定时器
              // 授权成功进行的操作
              this.saomaForm = res.data
              this.fuzhi()
            }
          }else{
            clearInterval(this.intervalId);
            this.intervalId = null // 重置定时器
          }
        } catch (error) {
          clearInterval(this.intervalId);
          this.intervalId = null // 重置定时器
          console.log(error,'失败');
        }
      }, 1000); // 1调用一次
    },
    fuzhi(){
      clearInterval(this.intervalId);
      this.intervalId = null // 重置定时器

      localStorage.setItem('token', this.saomaForm.result.userInfo.token);
      localStorage.setItem('isLogin', true);
      this.token=this.saomaForm.result.userInfo.token

      let vip_expire_time = this.saomaForm.result.userInfo.is_vip==0?'--':this.saomaForm.result.userInfo.vip_expire_time
      localStorage.setItem(
          "userInfo",
          JSON.stringify({
            sn: this.saomaForm.result.userInfo.sn,
            avatar: this.saomaForm.result.userInfo.avatar,
            nickname: this.saomaForm.result.userInfo.nickname,
            mobile: this.saomaForm.result.userInfo.mobile,
            is_supplier: this.saomaForm.result.userInfo.is_supplier,
            is_vip: this.saomaForm.result.userInfo.is_vip,
            vip_expire_time:vip_expire_time,
            supplier_id:this.saomaForm.result.userInfo.supplier_id,
            is_authentication:this.saomaForm.result.userInfo.is_authentication,
            supplier_is_authentication:this.saomaForm.result.userInfo.supplier_is_authentication,
            supplier_reject_reason:this.saomaForm.result.userInfo.supplier_reject_reason,
            
          })
        );

        this.supplier_id = this.saomaForm.result.userInfo.supplier_id

        this.getUserInfo()
        // 用户认证信息
        if(this.saomaForm.result.userInfo.is_authentication==2){
          this.getUserAuthentication()
        }
        // 供应商认证信息
        if(this.saomaForm.result.userInfo.supplier_is_authentication==2){
          this.getSupplierInfo()
        }

        this.$message({
          offset:80,
          message: "登录成功",
          type: "success",
        });

        if(this.saomaForm.result.userInfo.vip_tip==1){
            this.$notify({
                title: '',
                message: this.saomaForm.result.userInfo.vip_tip_message,
                duration: 0,
                offset: 50,
                position: 'bottom-right',
              })
          }

        this.$emit("message", {
          userInfo: this.saomaForm.result.userInfo,
          dialogVisible: false,
          chongxindiao:false,
        });

        clearInterval(this.intervalId);
        this.intervalId = null // 重置定时器
    }
  },
  mounted(){
    this.saomaLogin=true
    this.erweimazhezhao=false
    this.intervalId = null // 重置定时器
    if(localStorage.getItem('isLogin')==null || localStorage.getItem('isLogin')==undefined || localStorage.getItem('isLogin')==''){
      this.getQr()
    }
  },
  destroyed() {
    // 关闭验证码计时器
    clearInterval(this.timer);
    clearInterval(this.intervalId); 
  },
  watch:{
    chongxindiaoyong: {
        handler(newVal) {
            if(newVal && this.saomaLogin){
              this.getQr()
            }
        },
        deep: true
    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  position: relative;
  width: 1200px;
  height: 756px;
}

.left {
  width: 535px;
  // width: 481px;
  height: 760px;
  background-image: url("../../assets/images/login/beijing.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.right {
  width: 719px;
  height: 760px;
  background: #ffffff;
  // background: pink;
  border-radius: 16px 16px 16px 16px;
  position: absolute;
  right: 0;
  top: 0;
  .fanhui {
    text-align: right;
    margin-top: 16px;
    margin-right: 16px;
    font-size: 20px;
    color: #999999;

    span {
      cursor: pointer;
    }
  }
}

.marginA {
  margin-top: 4px;
}

.marginB {
  margin-top: 32px;
}

.logo {
  width: 100%;
  // background: paleturquoise;
  text-align: center;
  margin-top: 80px;
  img {
    width: 204px;
    height: 66px;
  }
}

.info {
  width: 558px;
  margin: 0 auto;
  margin-top: 32px;
  // 鼠标样式
  cursor: pointer;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #999999;
  line-height: 19px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  .tit {
    display: flex;
    justify-content: space-evenly;
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;

      font-weight: 500;
      font-size: 24px;
      color: #999999;
      line-height: 36px;
    }

    .background {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #064FAE;
      line-height: 36px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .line {
      width: 60px;
      height: 3px;
      background: #064FAE;
      border-radius: 0px 0px 0px 0px;
      margin-top: 6px;
    }
  }

  .el-btn {
    width: 558px;
    height: 80px;
    background: #064FAE;
    border-radius: 72px 72px 72px 72px;
    font-size: 32px;
  }

  .content {
    margin-top: 34px;
    .div {
      margin: 28px 0 48px;
    }

    .pwd {
      margin: 28px 0 24px;
    }

    .wangji {
      display: flex;
      justify-content: space-between;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #999999;
      font-style: normal;
      text-transform: none;
      margin-bottom: 25px;

      .jizhumiam{
        display: flex;
        align-items: center;
        img{
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
        span{
          margin-left: 8px;
        }

        div{
          display: inline-block;
          width: 18px;
          height: 18px;
          border: 1px solid #999;
          border-radius: 50%;
          box-sizing: border-box;
          cursor: pointer;
        }
      }
    }

    :deep(.el-radio) {
      .el-radio__label {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #999999;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  .rember {
    .el-input {
      margin-bottom: 16px;
    }
  }

  .phone {
    // width: 334px;
    width: 558px;
    height: 80px;
    :deep(.el-input__inner) {
      font-size: 20px;
      width: 558px;
      height: 80px;
      background: #f9f9f9;
      border-radius: 72px 72px 72px 72px;
      border: 0;
    }
    ::v-deep .el-input__inner::placeholder {
      color: #999; /* 将placeholder字体颜色修改为红色 */
    }

    ::v-deep .el-input__icon {
      font-size: 24px;
      line-height: 80px;
      margin-right: 8px;
    }

  }
  .number {
    width: 348px;
    height: 80px;
    margin-right: 6px;
    :deep(.el-input__inner) {
      width: 348px;
      height: 80px;
      background: #f9f9f9;
      border-radius: 72px 72px 72px 72px;
      border: 0;
      font-size: 20px;
    }
    ::v-deep .el-input__inner::placeholder {
      color: #999; /* 将placeholder字体颜色修改为红色 */
    }
    ::v-deep .el-input__icon {
      font-size: 24px;
      line-height: 80px;
      margin-right: 8px;
    }
  }

  .click,
  .click:hover {
    color: #999999;
    width: 201px;
    height: 80px;
    background: #f9f9f9;
    border-radius: 72px 72px 72px 72px;
    border: 0;
    padding: 0;
    font-size: 20px;
  }

  .is-active,
  .is-active:hover {
    background: #e7f3ff;
    color: #0073f5;
  }

  .saomadengl{
    font-weight: 500;
    font-size: 22px;
    color: #535C68;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    img{
      width: 30px;
      height: 30px;
      margin-right: 9px;
    }
  }
}


.tongyi {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;

  display: flex;
  justify-content: center;

  margin-top: 43px;

  span {
    color: #064FAE;
  }
}


.erweim{
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: default;
  .erweimaImg{
    // margin-top: 26rpx;
    width: 312px;
    height: 312px;
    background: #D9D9D9;
    border-radius: 0px 0px 0px 0px;
    img{
      width: 312px;
      height: 312px;
    }
  }

  .shuaxin{
    margin-top: 22px;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 24px;
    color: #535C68;

    .ssbtn{
      cursor: pointer;
      color: #064FAE;
      margin-left: 23px;
      display: flex;
      align-items: center;
      img{
        width: 21px;
        height: 21px;
        margin-right: 3px;
      }
    }
  }

  .anniuzu{
    display: flex;
    margin-top: 54px;

    .shoujibutn{
      cursor: pointer;
      width: 213px;
      height: 60px;
      background: #F9F9F9;
      border-radius: 100px 100px 100px 100px;

      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 20px;
      color: #666666;
      img{
        width: 24px;
        height: 24px;
        margin-right: 13px;
      }
    }

    .shouji{
      margin-right: 20px;
    }
  }
}

.erweimazhezhao{
  position: relative;
  filter: blur(4px);
  user-select: none;
}

:deep(.el-dialog) {
  width: 30%;
  // height: 200px;
  border-radius: 16px 16px 16px 16px;

  .el-dialog__header {
    padding: 20px 20px 10px !important;
  }

  .el-dialog__body {
    padding: 30px 20px !important;
  }
}
</style>